<template>
  <div>
    <loader :loading="loading"/>
    <page-title :moduleIdentifier="moduleIdentifier" :image="listLogo" :title="listTitle">
      <template slot="header-right">
        <slot name="header-actions"/>
      </template>
    </page-title>
    <panel :title="filterTitle">
      <span slot="header-right" class="badge badge--default">{{ $tc('items.found.label', total, { count: total }) }}</span>
      <div class="l-row">
        <slot name="filters"/>
      </div>
      <div class="u-textRight">
        <button type="reset" class="btn" @click="clearFilters">
          Limpar filtros
        </button>
        <button :disabled="loading" v-bind:class="{ 'is-loading': loading }" class="btn btn--success" type="submit" @click="onSearch">
          <i class="icon-search size"></i>
          Pesquisar
        </button>
      </div>
    </panel>
    <div class="actions">
      <div class="l-row">
        <div class="l-col-12@md">
          <div class="inline-flex">
            <slot name="top-actions"/>
            <div v-if="sortDefault && sortFields">
              <sort-select class="margin-right" ref="sortSelect" @change="onChangeSort" :fields="sortFields" :sortDefault="options.sortOrder" :fieldDefault="options.sortField"/>
            </div>
            <sort-numeric class="margin-right" ref="sortNumeric" @change="onChangeQuantityPage"/>
            <type-list class="margin-right" ref="typeList" @change="onChangeListPage" :typesListAvailable="typesListAvailable"/>
          </div>
        </div>
        <div class="l-col-12@md margin-bottom" v-if="$slots['top-actions-left-bottom'] || $slots['top-actions-right-bottom']">
          <div class="left">
            <div class="l-row">
              <slot name="top-actions-left-bottom"/>
            </div>
          </div>

          <div class="right">
            <slot name="top-actions-right-bottom"/>
          </div>
        </div>
      </div>
    </div>
    <div class="l-row vertical-flex">
      <slot/>
    </div>
    <div class="l-row">
      <slot name="bottom-actions"/>
    </div>
    <div class="paginator">
      <paginator :total="total" :limit="options.limit" ref="paginator" @change="onChangePage"/>
    </div>
  </div>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import SortSelect from '@/components/template/SortSelect'
  import SortNumeric from '@/components/template/SortNumeric'
  import TypeList from '@/components/template/TypeList'
  import Paginator from '@/components/template/Paginator'
  import PageTitle from '@/components/template/PageTitle'

  export default {
    data: () => ({
      options: {
        page: 1,
        limit: 15,
        sortField: null,
        sortOrder: null
      },
      listInitial: 'displayDetails'
    }),
    created () {
      if (this.sortDefault && this.sortFields) {
        if (this.sortDefault.field) {
          this.options.sortField = this.sortDefault.field
        }
        if (this.sortDefault.order) {
          this.options.sortOrder = this.sortDefault.order
        }
      } else {
        this.emitChange()
      }
    },
    mounted () {
      window.addEventListener('keyup', event => {
        if (event.key === 'Enter') {
          this.emitChange()
        }
      })
    },
    methods: {
      onSearch () {
        this.$refs.paginator.actualPage = this.options.page = 1
        this.emitChange()
      },
      onChangePage (page) {
        this.options.page = page
        this.emitChange()
      },
      onChangeSort (field, order) {
        this.options.sortField = field
        this.options.sortOrder = order
        this.emitChange()
      },
      onChangeQuantityPage (limit) {
        this.options.limit = limit
        this.emitChange()
      },
      onChangeListPage (value) {
        this.listInitial = value
      },
      emitChange () {
        if (!this.$refs.sortNumeric.created || (this.sortDefault && this.sortFields && !this.$refs.sortSelect.created)) {
          return false
        }

        this.$emit('change', this.options)
      },
      clearFilters () {
        for (let i in this.$parent.options) {
          this.$parent.options[i] = null
        }

        this.$emit('clearFilters')
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      filterTitle: {
        type: String,
        default: ' ',
        required: false
      },
      total: {
        type: Number,
        default: 0,
        required: true
      },
      sortFields: {
        type: Array,
        required: false
      },
      sortDefault: {
        type: Object,
        required: false
      },
      listLogo: {
        type: String,
        required: false
      },
      moduleIdentifier: {
        type: String,
        required: false
      },
      listTitle: {
        type: String,
        required: false
      },
      typesListAvailable: {
        type: Array,
        required: false
      }
    },
    components: {
      Panel,
      Loader,
      Paginator,
      SortSelect,
      SortNumeric,
      TypeList,
      PageTitle
    }
  }
</script>

<style lang="sass" scoped>
  .actions
    margin-bottom: 16px
    .right
      width: 50%
      float: right

    .left
      width: 50%
      float: left

  .selectAll
    cursor: pointer

  .margin-bottom
    margin-bottom: 16px

  .inline-flex
    display: inline-flex

  .margin-right
    margin-right: 5px
</style>



// WEBPACK FOOTER //
// Paginator.vue?80ae6da4